import { render, staticRenderFns } from "./DatatableMatrixList.vue?vue&type=template&id=db319b96"
import script from "./DatatableMatrixList.vue?vue&type=script&lang=js"
export * from "./DatatableMatrixList.vue?vue&type=script&lang=js"
import style0 from "./DatatableMatrixList.vue?vue&type=style&index=0&id=db319b96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports